import { Component } from '@angular/core';
import { SideMenuComponent } from '../side-menu/side-menu.component';
import { environment } from '../../environments/environment';
import { LangChangeEvent, TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-organization-chart',
  standalone: true,
  imports: [SideMenuComponent, TranslateModule, CommonModule],
  templateUrl: './organization-chart.component.html',
  styleUrl: './organization-chart.component.css'
})
export class OrganizationChartComponent {

  baseApiUrl = environment.baseApiUrl;

  currentLanguage: string = '';

  constructor(private translate: TranslateService) {

  }

  ngOnInit(): void {
    this.currentLanguage = this.translate.currentLang || this.translate.defaultLang;

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.currentLanguage = event.lang;
    })
  }

}
